import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCcAmex,
  faCcApplePay,
  faCcDiscover, faCcMastercard, faCcVisa,
  faGoogle
} from '@fortawesome/free-brands-svg-icons';
import { faCopy as farCopy } from '@fortawesome/free-regular-svg-icons';
import {
  faChevronDown,
  faChevronUp,
  faCloudUploadAlt,
  faCopy,
  faDownload,
  faEdit,
  faExclamationCircle,
  faExternalLinkAlt,
  faPen,
  faPlus,
  faSearch,
  faSort,
  faSpinner,
  faStar,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BootstrapVue from 'bootstrap-vue';
import VCalendar from 'v-calendar';
import VueMask from 'v-mask';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';
import VueGtm from 'vue-gtm';
import VueMatchHeights from 'vue-match-heights';
import VueUploadComponent from 'vue-upload-component';
import * as VueGoogleMaps from 'vue2-google-maps';
import Autocomplete from 'vuejs-auto-complete';
import Vuelidate from 'vuelidate';
import FILTERS from './lib/filters';

// Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min';
// Import third party plugins
import 'froala-editor/js/plugins/link.min';
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/image_tui.min';

// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';

import App from './App.vue';
import router from './router';
import store from './store/index';

import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import './global.scss';

library.add(
  faSpinner,
  faEdit,
  faCopy,
  faDownload,
  faChevronDown,
  faChevronUp,
  faCloudUploadAlt,
  faStar,
  faCcAmex,
  faCcDiscover,
  faCcMastercard,
  faCcVisa,
  faCcApplePay,
  faGoogle,
  faSort,
  faSearch,
  faExclamationCircle,
  farCopy,
  faPlus,
  faPen,
  faExternalLinkAlt,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('autocomplete', Autocomplete);

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors',
});
Vue.use(VueFroala);
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM,
  enabled: true,
  debug: false,
  vueRouter: router,
  ignoredViews: [],
});
Vue.use(VueMask);
Vue.use(VCalendar);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCH45qvGquCdYu31PbsiK7RqDLo2J51sDA',
    libraries: 'places', // necessary for places input
  },
});
Vue.component('file-upload', VueUploadComponent);
Vue.use(VueMatchHeights);

Vue.config.productionTip = false;

// Filters
Vue.filter('dateOnly', FILTERS.dateOnly);
Vue.filter('dateOnlyLong', FILTERS.dateOnlyLong);
Vue.filter('dateTime', FILTERS.dateTime);
Vue.filter('dateAtTime', FILTERS.dateAtTime);
Vue.filter('telephoneNumber', FILTERS.telephoneNumber);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
